<template>
  <button
    type="button"
    class="chart-image-download inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-gray-modern-200 bg-white px-2.5 py-1.5 font-sans text-xs font-semibold text-gray-modern-600 transition hover:border-gray-modern-300 hover:bg-gray-modern-50 hover:text-gray-modern-800 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-40"
    :disabled="disabled || busy"
    :aria-busy="busy"
    title="Download chart as PNG image"
    @click="$emit('click')"
  >
    <DownloadIcon class="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
    <span>{{ busy ? "Saving…" : "Image" }}</span>
  </button>
</template>

<script setup>
import DownloadIcon from "./icons/DownloadIcon.vue";

defineProps({
  disabled: { type: Boolean, default: false },
  busy: { type: Boolean, default: false },
});

defineEmits(["click"]);
</script>
